import React, {Component} from 'react';

import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import overlayFactory from 'react-bootstrap-table2-overlay';

import urls from "../../../utils/urls";
import {tokenHeader} from "../../../utils/headers";
import EmptyRow from '../../../components/EmptyState/emptyRows';
import Datepicker from "../../../components/Datepicker/datepicker";
import {ajaxHandler} from "../../../utils/errors";
import helpers from "../../../utils/helpers";

class ControlMeters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            xhr: false,
            axiosSource: false,
            ajaxInProgress: false,
            products: false,
            terminals: false,
            meters: false,
            unload_started_gt: '',
            unload_started_lt: '',
            product: '',
            terminal: '',
            meter: '',
            extra: '',
            page: 1,
            total_trips: 0,
            rows: false
        }
    }

    componentDidMount(){
        this._fetchOptions();
        this._fetchReport();
    }

    _initializeHTML(){
        window.initializeSelects('.filter');
        window.bindSelectAction(this.productSelect, this._handleSelectChange);
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
        window.bindSelectAction(this.meterSelect, this._handleSelectChange);
        window.bindSelectAction(this.extraSelect, this._handleSelectChange);
    }

    _fetchOptions = () => {

        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        const meters = `${urls.API_ROOT}/api/v1/meters/`;
        axios.all([
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
            axios.get(meters, tokenHeader()),
        ])
            .then(axios.spread(function (terminal, prod, meters) {
                return {
                    terminals: terminal,
                    products: prod,
                    meters
                }
            }))
            .then((data) => {
                this.setState({
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === helpers.trip_type.FE),
                    meters: data.meters.data
                }, this._initializeHTML)
            })
            .catch(ajaxHandler)
    };

    _handleDateChange = (prop, value) => {
        this.setState({
            [prop]: value,
            page: 1
        }, this._fetchReport);
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({
            [prop]: target.value,
            page: 1
        }, () => {
            this._fetchReport();
            this._initializeHTML();
        });
    };

    _emptyFilters = () => {
        this.setState({
            unload_started_gt: '',
            unload_started_lt: '',
            product: '', terminal: '', meter: '', extra: ''
        }, () => {
            this._fetchReport();
            window.reInitializeSelects('.filter');
        });
    };

    _generateNewQuery = () => {
        const getParams = this._generateParams();
        return `${urls.API_ROOT}/api/v1/report-discharge/${getParams}`;
    };

    _generateParams = () => {
        let params = `?`;
        let filters = ['unload_started_gt', 'unload_started_lt', 'terminal', 'product', 'meter'];
        filters.forEach(filter => {
            let value = this.state[filter];
            if (value && value !== '') {
                params = `${params}${filter}=${value}&`;
            }
        });

        if(this.state.extra !== ''){
            params = `${params}${this.state.extra}&`;
        }

        if(this.state.page > 1){
            params = `${params}page=${this.state.page}&`;
        }

        return params
    };

    _fetchReport = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});
        const task_url = this._generateNewQuery();
        axios.get(task_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {
                this.setState({
                    rows: response.data.results,
                    xhr: false,
                    axiosSource: null,
                    total_trips: response.data.count
                });
            })
            .catch((error) => {
                this.setState({rows: [], xhr: false});
                ajaxHandler(error)
            })
    };

    _onTableChange = (type, { page, sizePerPage, filters }) => {
        this.setState({page}, this._fetchReport);
    };

    rowEvents = {
        onClick: (e, row, rowIndex) => {
            this.props.history.push(`/trips/${row.trip}`);
        }
    };

    render() {

        let {unload_started_gt, unload_started_lt, meters, product, terminal} = this.state;

        let minDate = (unload_started_gt !== '') ? moment(unload_started_gt, 'YYYY-MM-DD').toDate() : false;
        let maxDate = (unload_started_lt !== '') ? moment(unload_started_lt, 'YYYY-MM-DD').toDate() : false;

        // Pagination
        const pagination = paginationFactory({
            page: this.state.page,
            sizePerPage: 10,
            totalSize: this.state.total_trips,
            hideSizePerPage: true
        });


        const columns = helpers.getMeterReportColumns();
        let data = [];
        if (this.state.rows && this.state.rows instanceof Array) {
            this.state.rows.forEach(discharge => {
                let row = {id: discharge.id};
                columns.forEach(col => {
                    row[col.dataField] = _.get(discharge, col.path, '-');
                    if(!row[col.dataField] || row[col.dataField] === ''){
                        row[col.dataField] = '-';
                    }
                    if(col.custom){
                        switch(col.dataField){
                            case 'provider_load_volume':
                                row[col.dataField] = `${row[col.dataField]} (${discharge.product.origin_unit_of_measure}${discharge.product.origin_density ? ` a ${discharge.product.origin_density}º` : ""})`;
                                break;
                            case 'unloaded_volume':
                                row[col.dataField] = `${row[col.dataField]} (${discharge.product.terminal_unit_of_measure}${discharge.product.terminal_density ? ` a ${discharge.product.terminal_density}º` : ""})`;
                                break;
                            default:
                                row[col.dataField] = '-';
                                break;
                        }
                    }
                });
                data.push(row);
            });
        }

        if(terminal){
            meters = meters.filter(m => m.loading_island.terminal.id === parseInt(terminal, 10));
        }
        if(product){
            meters = meters.filter(m => m.product.id === parseInt(product, 10));
        }

        return (
            <div>
                <div className={'filter'}>
                    <div className={'row no-margin'}>
                        <div className={'col s2 input-field'}>
                            <select defaultValue={this.state.terminal} data-state-var="terminal"
                                    ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Todos</option>
                                {this.state.terminals && this.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                            <label>Destino</label>
                        </div>
                        <div className={'col s2 input-field'}>
                            <select defaultValue={this.state.product} data-state-var="product"
                                    ref={ref => { this.productSelect = ref }}>
                                <option value="">Todos</option>
                                {this.state.products && this.state.products.map(product => {
                                    return <option key={product.id} id={product.id}
                                                   value={product.id}>{product.name}</option>
                                })}
                            </select>
                            <label>Producto</label>
                        </div>
                        <div className={'col s3 input-field'}>
                            <select defaultValue={this.state.meter} data-state-var="meter"
                                    ref={ref => {this.meterSelect = ref}}>
                                <option value="">Todos</option>
                                {meters && meters.map(meter => {
                                    return <option key={meter.id} id={meter.id}
                                                   value={meter.id}>{meter.loading_island.name} - {meter.description}</option>
                                })}
                            </select>
                            <label>Meter</label>
                        </div>
                        <div className={'col s2 input-field'}>
                            <select defaultValue={this.state.extra} data-state-var="extra"
                                    ref={ref => {this.extraSelect = ref}}>
                                <option value="">Todos</option>
                                <option value="meter_works=False">Meter no funcional</option>
                                <option value="needs_review=True">Auditoría realizada</option>
                            </select>
                            <label>Tipo de Registro</label>
                        </div>
                        <div className={'col s3'}>
                            <div className={"row"}>
                                <div className={'col s6 input-field no-margin'}>
                                    <Datepicker value={unload_started_gt} format={"YYYY-MM-DD"} alwaysRestart={true}
                                                id="unload_started_gt" action={this._handleDateChange} max={maxDate}
                                                classname="" style={{position: 'relative', marginTop: 15}}/>
                                    <label className={"active"} style={{transform: 'translateY(-85%)'}}>Fecha de descarga</label>
                                </div>
                                <div className={'col s6 input-field no-margin'}>
                                    <div style={{position: 'absolute', left: 0, top: 13}}>
                                        <p style={{position: 'absolute'}}>a</p>
                                    </div>
                                    <Datepicker value={unload_started_lt} format={"YYYY-MM-DD"} alwaysRestart={true}
                                                id="unload_started_lt" action={this._handleDateChange} min={minDate}
                                                classname="" style={{position: 'relative', marginTop: 15, marginLeft: 5}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row text-right thin-row"}>
                        <div className={"col s12"}>
                            <div onClick={this._emptyFilters} className={"pointer"} style={{
                                color: "#000000",
                                fontWeight: 'bold'
                            }}>
                                Borrar filtros
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'main-table fixed-height-table '}>
                    <BootstrapTable
                        remote
                        keyField='id'
                        classes={'striped highlight bordered custom-black-table'} bordered={false}
                        data={data} columns={columns}
                        noDataIndication={()=>{return <EmptyRow text={"No hay información disponible"} />}}
                        pagination={pagination}
                        rowEvents={this.rowEvents}
                        loading={ this.state.xhr }
                        overlay={ overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.85)', text:'Cargando consulta...' }) }
                        onTableChange={this._onTableChange}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(ControlMeters);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Reports/ControlMeters.js